module.exports = __webpack_public_path__ + "static/media/icon_sue_1.7794004a.svg";